import { createIndex as universalCreateIndex, dropIndex as universalDropIndex, listIndexes as universalListIndexes, } from './data-v2-index-indexes.universal';
export const __metadata = { PACKAGE_NAME: '@wix/data' };
export function createIndex(httpClient) {
    return (dataCollectionId, index) => universalCreateIndex(dataCollectionId, index, 
    // @ts-ignore
    { httpClient });
}
export function dropIndex(httpClient) {
    return (dataCollectionId, indexName) => universalDropIndex(dataCollectionId, indexName, 
    // @ts-ignore
    { httpClient });
}
export function listIndexes(httpClient) {
    return (dataCollectionId, options) => universalListIndexes(dataCollectionId, options, 
    // @ts-ignore
    { httpClient });
}
export { Environment, Order, Status, } from './data-v2-index-indexes.universal';
//# sourceMappingURL=data-v2-index-indexes.public.js.map